var _defs, _ellipse, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _polygon, _rect7, _rect8, _polygon2, _rect9, _rect10, _rect11, _polygon3, _polygon4, _polygon5, _polygon6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRPackers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1090d0;}.cls-2{fill:#a7a9ac;}.cls-3{fill:#6d6e71;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 50.08,
    cy: 71.44,
    rx: 8.93,
    ry: 10.45
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.31,
    y: 5.84,
    width: 11.53,
    height: 14.64
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45.49,
    y: 81.95,
    width: 9.18,
    height: 5.33
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.23,
    y: 87.07,
    width: 7.7,
    height: 2.54
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 46.23,
    y: 89.54,
    width: 7.7,
    height: 4.62
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.74,
    y: 23.82,
    width: 18.68,
    height: 2.48
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 40.74,
    y: 26.24,
    width: 18.68,
    height: 13.04
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "58.99 23.95 41.16 23.95 44.28 20.39 55.87 20.39 58.99 23.95"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.74,
    y: 39.21,
    width: 18.68,
    height: 2.48,
    transform: "translate(100.15 80.9) rotate(180)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.74,
    y: 77.85,
    width: 18.68,
    height: 4.69,
    transform: "translate(100.15 160.39) rotate(180)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "41.16 41.56 58.99 41.56 55.87 52.21 44.28 52.21 41.16 41.56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45.75,
    y: 51.2,
    width: 8.65,
    height: 10.7
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 47.23,
    y: 70.32,
    width: 5.69,
    height: 6.22
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 47.23,
    y: 62.7,
    width: 5.69,
    height: 6.22
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "45.45 70.24 45.45 74.66 42.85 76.65 40.25 76.65 40.25 70.3 45.45 70.24"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "40.25 69.11 40.25 64.69 42.85 62.7 45.45 62.7 45.45 69.05 40.25 69.11"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "59.75 69.11 59.75 64.69 57.15 62.7 54.55 62.7 54.55 69.05 59.75 69.11"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "54.55 70.24 54.55 74.66 57.15 76.65 59.75 76.65 59.75 70.3 54.55 70.24"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRPackers);
export default __webpack_public_path__ + "static/media/RPackers.9fc9125572c21c044253144e47f428ae.svg";
export { ForwardRef as ReactComponent };